/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { object, shape, string } from 'prop-types';
import { decodeHTML } from 'entities';
import mbpLogger from 'mbp-logger';
import { GRAPHQL_ENV } from '../../../../gql';
import { getBrand } from '../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import SubCollectionCarousel from './SubCollectionCarousel';
import SubCollectionStandard from './SubCollectionStandard';

const  SubCollectionSelector = ({ brand, dataObj, ssrDeviceType }) => {
    const {
        heading, collectionLink, presentationType, collectionId, devicePageSize, subcollectionBrand, trackData,
    } = dataObj;
    const subBrand = subcollectionBrand || brand['domain-name'];
    const FINDCATEGORY_BY_ID = gql`
    query {
        findCategoryById(brand: "${subBrand}", id: "${collectionId}", environment: "production", locale: "en-us", productOptions:{page:1, pageSize:${devicePageSize}}) {
            products {
                id, name, image {name, path}, partNumber,
                availability {
                    deliveryMessage
                },
                prices {
                    currency
                    type
                    value
                }
                skuPriceRange {
                    sale {type, value},
                    retail {type, value}
                }
                seo {
                    url
                    title
                }
            }
        }
    }`;

    return (
        <Query query={FINDCATEGORY_BY_ID}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }
                if (error) {
                    mbpLogger.logError({
                        query: FINDCATEGORY_BY_ID,
                        component: ' SubCollectionSelector.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        query: FINDCATEGORY_BY_ID,
                        component: ' SubCollectionSelector.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data.findCategoryById || !data.findCategoryById.products) {
                    mbpLogger.logWarning({
                        query: FINDCATEGORY_BY_ID,
                        component: ' SubCollectionSelector.js',
                        message: 'No product returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                const graphqlProducts = data?.findCategoryById?.products || null;
                // Adding image.url for subcollection carousel and standard

                const products = [];
                graphqlProducts.forEach((product) => {
                    const productData = { ...product };
                    productData.name = decodeHTML(productData.name);
                    if (productData?.image?.length) {
                        // adding url attribute to image by combining image.path and image.name
                        if (productData.image.path && productData.image.name) {
                            productData.image.url = [productData.image.path, productData.image.name, 'c.jpg'].join('');
                        } else {
                            productData.image.url = '';
                        }
                    }
                    products.push(productData);
                });
                if (products && products.length) {
                    const productObj = {
                        heading, collectionLink, products, brand,
                    };
                    if (presentationType === 'Carousel') return <SubCollectionCarousel trackData={trackData} data={productObj} ssrDeviceType={ssrDeviceType} />;
                    if (presentationType === 'Standard') return <SubCollectionStandard trackData={trackData} data={productObj} ssrDeviceType={ssrDeviceType} />;
                }
                return null;
            }}
        </Query>
    );
};

SubCollectionSelector.propTypes = {
    brand: object.isRequired,
    ssrDeviceType: string.isRequired,
    dataObj: shape({
        id: string.isRequired,
        title: string.isRequired,
        collectionLink: string.isRequired,
        presentationType: string.isRequired,
        trackData: shape({
            tracking_event_action: string,
            tracking_event_category: string,
            tracking_event_label: string,
        }),
    }).isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(SubCollectionSelector);
